<template>
  <div>
    <v-card class="mb-10" v-if="data_loaded">
      <v-divider></v-divider>
      <v-card-text class="pb-0">
        <v-form ref="form">
          <v-row class="mt-2">
            <v-col class="py-0" cols="12">
              <v-textarea
                v-model="settings.closed_msg"
                outlined
                label="closed_msg"
              >
                <template slot="append">
                  <v-switch
                    hide-details
                    v-model="settings.show_closed_msg"
                  ></v-switch>
                </template>
              </v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "closedMsg",
  props: ["settings", "data_loaded"],
  data() {
    return {};
  },
};
</script>
